module.exports = MaterialUI.Tabs;